import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import BrandPanel from './BrandPanel';

const Login: React.FC = () => {
  const { login } = useAuth();

  return (
    <BrandPanel>
      <h1 className="h3">Dangerous Goods Classifier</h1>
      <p className="text-subtitle2 text-sm">Sign in with your Hazcheck account to continue</p>
      <button onClick={login} className="btn btn-primary btn-lg login-button">
        Sign in
      </button>
    </BrandPanel>
  );
};

export default Login;
